import { Component, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { scan } from 'rxjs/operators';

import { demos } from '../../routes';
import {
  DemoContext,
  DemoSources,
  DemoSourceType
} from '../../shared/interfaces';
import { datasourceGetCallbackInfinite } from '../../shared/datasource-get';

import { Datasource } from 'ngx-ui-scroll';

@Component({
  selector: 'app-demo-is-loading',
  templateUrl: './is-loading.component.html',
  standalone: false
})
export class DemoIsLoadingComponent {
  demoContext: DemoContext = {
    config: demos.adapterProps.map.isLoading,
    viewportId: 'is-loading-viewport',
    count: 0,
    log: signal('')
  };

  datasource = new Datasource({
    get: datasourceGetCallbackInfinite(this.demoContext, 225)
  });

  sources: DemoSources = [
    {
      name: DemoSourceType.Component,
      text: `datasource = new Datasource ({
  get: (index, count, success) => {
    const data = [];
    for (let i = index; i <= index + count - 1; i++) {
      data.push({ id: i, text: 'item #' + i });
    }
    setTimeout(() => success(data), 225);
  }
});

isLoadingCounter = toSignal(
  this.datasource.adapter.isLoading$.pipe(
    scan((count, isLoading) => count + (!isLoading ? 1 : 0), 0)
  ),
  { initialValue: 0 }
);
`
    },
    {
      active: true,
      name: DemoSourceType.Template,
      text: `The Scroller is
{{(datasource.adapter.isLoading$ | async) ? 'loading' : 'relaxing'}}.

<br>

The value of isLoading counter has been changed
for {{isLoadingCounter()}} times.

<div class="viewport">
  <div *uiScroll="let item of datasource">
    <div class="item">{{item.text}}</div>
  </div>
</div>`
    },
    {
      name: DemoSourceType.Styles,
      text: `.viewport {
  width: 150px;
  height: 250px;
  overflow-y: auto;
}
.item {
  font-weight: bold;
  height: 25px;
}`
    }
  ];

  isLoadingCounter = toSignal(
    this.datasource.adapter.isLoading$.pipe(
      scan((count, isLoading) => count + (!isLoading ? 1 : 0), 0)
    ),
    { initialValue: 0 }
  );
}
